<template>
  <div class="step step--school-known">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <div xl="7" md="8" sm="12">
          <div class="mb-4">
            <icon-school class="step__icon" />
            <h2>Do you have any schools picked out?</h2>
          </div>
          <div class="step__buttons">
            <div class="button-radio btn btn-primary btn-block">
              <input id="school-known-yes" type="radio" v-model="user.schoolKnown" value="yes"> <label for="school-known-yes">Yes</label>
            </div>
            <div class="button-radio btn btn-primary btn-block">
              <input id="school-known-no" type="radio" v-model="user.schoolKnown" value="no"> <label for="school-known-no">No</label>
            </div>
          </div>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBack from '../buttons/Back.vue'
import IconSchool from '../animatedicons/IconSchool.vue'
import Disclaimer from '../Disclaimer.vue'

export default {
  name: 'SchoolKnownStep',
  props: {
    user: Object
  },
  methods: {
    back: function () {
      this.$emit('back');
    }
  },
  mounted: function () {
    this.user.schoolKnown = null;
  },
  watch: {
    'user.schoolKnown': function () {
      if (this.user.schoolKnown) {
        this.$emit('completed');
      }
    },
  },
  components: {
    IconSchool,
    ButtonBack,
    Disclaimer,
  }
}
</script>

<style scoped>
</style>
